var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "font-size-14" },
    [
      _c(
        "yxt-form",
        { ref: "ruleForm", attrs: { "label-width": "100px" } },
        [
          _c(
            "yxt-form-item",
            {
              staticClass: "color-gray-9",
              attrs: {
                prop: "entryTime",
                label: _vm.$t("pc_biz_ote_lbl_marker"),
              },
            },
            [
              _c(
                "yxt-radio-group",
                {
                  attrs: { direction: "row", disabled: _vm.status !== 0 },
                  model: {
                    value: _vm.markerData.markType,
                    callback: function ($$v) {
                      _vm.$set(_vm.markerData, "markType", $$v)
                    },
                    expression: "markerData.markType",
                  },
                },
                [
                  _c("yxt-radio", { attrs: { label: 3 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_markerset1"))),
                  ]),
                  _c("yxt-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_markerset2"))),
                  ]),
                  _c("yxt-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_markerset3", [50]))),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "ml24" }, [
                _vm.markerData.markType === 0
                  ? _c(
                      "div",
                      { staticClass: "mt5" },
                      [
                        _c(
                          "yxt-button",
                          {
                            attrs: {
                              disabled: _vm.status !== 0,
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addMarker()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_addpeople")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.markerData.markType === 0
                  ? _c("div", { staticClass: "mt10" }, [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-exam-arrange__selection" },
                        [
                          _c(
                            "yxt-scrollbar",
                            { attrs: { "fit-height": true } },
                            _vm._l(_vm.markers, function (item) {
                              return _c(
                                "yxt-tag",
                                {
                                  key: item.id,
                                  staticClass: "mr5",
                                  staticStyle: { "margin-bottom": "5px" },
                                  attrs: {
                                    size: "small",
                                    type: "info",
                                    closable: "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.deleteItem(item)
                                    },
                                  },
                                },
                                [
                                  _c("yxt-svg", {
                                    staticClass: "mr5 v-mid",
                                    attrs: {
                                      width: "14px",
                                      height: "14px",
                                      "icon-class": "person-center",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "yxtbiz-user-selector-tag" },
                                    [
                                      _c("yxtbiz-user-name", {
                                        attrs: { name: item.fullname },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectUsersDialogData.dialogVisible
        ? _c("select-users", {
            attrs: {
              functionCode: _vm.functionCode,
              dataPermissionCode: _vm.dataPermissionCodes.selectMarker,
              states: _vm.selectUsersDialogData,
            },
            on: {
              selectUsersCallback: _vm.selectUsersCallback,
              closeSelectDrawer: _vm.closeSelectDrawer,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }